import { IconProps, SvgIconProps } from "@mui/material"
import { enRules } from "interfaces/IUser"
import { ComponentType } from "react"
import { IconBaseProps } from "react-icons"
import { FaBalanceScale } from "react-icons/fa"
import { FaCartFlatbed } from "react-icons/fa6"
import { MdOutlineSimCardAlert, MdSpaceDashboard } from "react-icons/md"
import { RiSettings4Fill } from "react-icons/ri"

export interface INavConfig {
  title: string
  path: string
  icon: ComponentType<IconBaseProps> | ComponentType<IconProps> | ComponentType<SvgIconProps>
  permissions: enRules[]
  children?: INavConfig[]
}

const NavConfig: INavConfig[] = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: MdSpaceDashboard,
    permissions: [enRules.Tech, enRules.ReplenishmentDashboardView],
  },
  {
    title: "Balanço",
    path: "balanco",
    icon: FaBalanceScale,
    permissions: [enRules.Tech, enRules.ReplenishmentBalanceView],
  },
  {
    title: "Abastecimentos",
    path: "abastecimentos",
    icon: FaCartFlatbed,
    permissions: [enRules.Tech, enRules.ReplenishmentReplenishmentsView],
  },
  {
    title: "Sem Estoque",
    path: "sem-estoque",
    icon: MdOutlineSimCardAlert,
    permissions: [enRules.Tech, enRules.ReplenishmentStockoutView],
  },
  {
    title: "Configurações",
    path: "configuracoes",
    icon: RiSettings4Fill,
    permissions: [enRules.Tech, enRules.ReplenishmentConfigsView],
  },
]

export default NavConfig
